<template>
    <div id="ra-general-information">
        <v-card-title class="pb-0">
            <v-icon :color="kingsGold" left>mdi-home-edit</v-icon> Placement Preference
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-medical-bag</v-icon>Standard First Aid Training
                    <br>
                    You are required to complete Standard First Aid training (Typically a 2 day course) prior to
                    training week and
                    provide proof of certification. King’s does not reimburse the cost of the training.
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12" lg="4">
                        <v-text-field v-model="item.firstAidTrainingInitials" hide-details
                            label="I understand (please initial)" prepend-icon="mdi-draw" placeholder="Not Available"
                            readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-card-account-details</v-icon>Canadian Social Insurance
                    Number
                    <br>
                    You are required to have a Canadian Social Insurance Number card (SIN) by the end of August
                    for payroll
                    purposes.
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12" lg="4">
                        <v-text-field v-model="item.sinCardInitials" hide-details label="I understand (please initial)"
                            prepend-icon="mdi-draw" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="pb-0 px-0">
                    <v-icon :color="kingsGold" left>mdi-allergy</v-icon>Food/Allergies Concern(s)
                    Number
                    <br>
                    Please advise us of any other allergies, food concerns or circumstances that you feel we
                    should know about when planning RA training week. Check boxes for Vegetarian, Vegan, Gluten
                    Intolerant, Lactose Intolerant, Food Allergies
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12" class="pt-4">
                        <v-textarea v-model="item.allergiesConcern" auto-grow hide-details
                            label="Food/Allergies Concern(s)" outlined persistent-hint placeholder="None" readonly>
                        </v-textarea>
                    </v-col>
                </v-row>
                <v-card-subtitle class="pb-0 px-0">
                    <v-icon :color="kingsGold" left>mdi-calendar-remove</v-icon>Need To Miss Training On Certain
                    Day(s)
                    <br>
                    If there are certain training days that you need to miss, please provide us the dates and
                    reasoning.
                </v-card-subtitle>
                <v-list v-if="item.trainingDaysMissed && item.trainingDaysMissed.length > 0">
                    <v-list-item v-for="(item,i) in item.trainingDaysMissed" :key="i">
                        <v-list-item-icon>
                            <v-icon :color="dangerColor">mdi-calendar-alert</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.date }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.reason }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-alert v-else :color="infoColor" dense icon="mdi-information" text>
                    There are no training day(s) provided that must be missed.</v-alert>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-tshirt-crew</v-icon>You will receive an RA shirt
                </v-card-subtitle>
                <v-radio-group v-model="item.shirtSize" label="Shirt size" readonly>
                    <v-radio v-for="(item, index) in shirtSizeItems" :key="index" :label="item.text"
                        :value="item.value"></v-radio>
                </v-radio-group>
                <v-radio-group v-model="item.shirtStyle" class="mt-4" label="Shirt style" readonly>
                    <v-radio v-for="(item, index) in shirtStyleItems" :key="index" :label="item.text"
                        :value="item.value"></v-radio>
                </v-radio-group>
                <v-text-field v-model="item.shirtDescription" label="Name to appear on the shirt"
                    placeholder="Not Avaiable" readonly>
                </v-text-field>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-human-greeting</v-icon>Tour Room
                    <br>
                    Residents have the opportunity to apply to be a tour room for prospective students and be
                    paid an honorarium for this role. As a tour room, your role will be to show your room to
                    students who are touring King's residence as they consider applying' to King's, and act as a
                    King's ambassador. If you are interested in this role, please indicate this by selecting
                    <b>YES</b> below.
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-radio-group v-model="item.tourRoom" readonly>
                            <v-radio v-for="(item, index) in tourRoomItems" :key="index" :label="item.text"
                                :value="item.value"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'ra-application-general-information',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            shirtSizeItems: [{
                    text: 'XS',
                    value: 'XS'
                },
                {
                    text: 'S',
                    value: 'S'
                }, {
                    text: 'M',
                    value: 'M'
                },
                {
                    text: 'LG',
                    value: 'LG'
                },
                {
                    text: 'XL',
                    value: 'XL'
                },
                {
                    text: 'XXL',
                    value: 'XXL'
                }
            ],
            shirtStyleItems: [{
                    text: `Men's style`,
                    value: 'M'
                },
                {
                    text: 'Ladies style',
                    value: 'F'
                }
            ],
            tourRoomItems: [{
                    text: 'YES, I am interested in this role',
                    value: 'Yes'
                },
                {
                    text: 'NO, I am not interested in this role',
                    value: 'No'
                }
            ]
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        }
    }
}
</script>

<style scoped>
.v-card__subtitle {
    font-weight: bold;
}

.v-input--checkbox,
.v-input--radio-group {
    margin-top: 0;
}
</style>